import { isEntity } from '@tunasong/schemas'
import type { Entity, EntityId } from '@tunasong/schemas'

export interface PlayList extends Entity {
  type: 'playlist'
  /** References to the ids of the media in the playlist */
  mediaIds: EntityId[]
  /**
   * Server-owned (GH #2233): media flagged at an ownership transfer, not lent to readers until the owner confirms
   * them with POST /entities/{id}/media/confirm
   */
  unconfirmedMediaIds?: EntityId[]
}

export function isPlayList(node?: unknown): node is PlayList {
  return Boolean(isEntity(node) && node.type === 'playlist')
}
